import type { FC, ReactNode } from 'react'

import { brandHighlightIcon, highlights } from '@/constants/content'

interface HighlightsProps {
    brandCount: number
}

export const Highlights: FC<HighlightsProps> = ({ brandCount }): ReactNode => {
    const items = [
        ...highlights,
        {
            icon: brandHighlightIcon,
            title: brandCount > 0 ? `${brandCount}+ leading brands` : 'Leading brands',
            text: 'Samsung, Paytm, BookMyShow, Star Sports and more.'
        }
    ]

    return (
        <section id='highlights' aria-label='Highlights' className='bg-night text-white'>
            <div className='mx-auto grid max-w-7xl px-6 sm:grid-cols-2 sm:gap-x-10 lg:grid-cols-4 lg:gap-x-0'>
                {items.map(({ icon: Icon, title, text }) => (
                    <div
                        key={title}
                        className='flex flex-col gap-4 border-b border-white/10 py-10 last:border-b-0 sm:[&:nth-last-child(-n+2)]:border-b-0 lg:border-b-0 lg:border-l lg:px-8 lg:py-14 lg:first:border-l-0 lg:first:pl-0'
                    >
                        <Icon className='size-6 text-gold' aria-hidden='true' />

                        <p className='font-heading text-3xl leading-tight'>
                            {title}
                        </p>

                        <p className='text-sm leading-relaxed text-white/60'>
                            {text}
                        </p>
                    </div>
                ))}
            </div>
        </section>
    )
}
